const stateWiseACDetails = {
  Maharashtra: {
    acType: "Split",
    ton: "10",
    plan: "3+2year",
    quantity: 1,
    subscription_plan: 1425,
    depositamount: 6000,
    installetionCharge: 1800,
    extraCharge: 349,
    itemId: "mc_3y_1.0",
    totalSubscription: 1425,
    totalDeposit: 6000,
    totalInstallation: 1800,
    priceAfter3Years: 950,
    totalAfter3Years: 950,
    totalAmount: 9225,
  },
  Delhi: {
    acType: "Split",
    ton: "10",
    plan: "3+3year",
    quantity: 1,
    subscription_plan: 1625,
    depositamount: 6000,
    installetionCharge: 2000,
    extraCharge: 400,
    itemId: "mc_3y_1.0",
    totalSubscription: 1625,
    totalDeposit: 6000,
    totalInstallation: 2000,
    priceAfter3Years: 1100,
    totalAfter3Years: 1100,
    totalAmount: 9625,
  },
  // Add more states as needed
};

export default stateWiseACDetails;
